import { Box, circularProgressClasses } from '@mui/material';
import { PrimaryButton, TextButton, GrayButton, LinkButton, BlueLinkButton, GreenButton, RedBorderButton, BlueButton, BlackButton, RedTextButton, GrayBorderButton, BlueBorderButton, BaseButton, OutlinedButton, LoadingButtonContainer, CMGrayProgress, CMProgress } from './button.styles';

export const BUTTON_TYPE_CLASSES = {
  BaseButton: 'base-button',
  OutlinedButton: 'outlined-button',
  TextButton: 'text-button',
}

const getButton = (buttonType = BUTTON_TYPE_CLASSES.BaseButton) => (
  {
    [BUTTON_TYPE_CLASSES.BaseButton]: BaseButton,
    [BUTTON_TYPE_CLASSES.OutlinedButton]: OutlinedButton,
    [BUTTON_TYPE_CLASSES.TextButton]: TextButton,
  }[buttonType]
)

const Button = ({ children, buttonType, isProgressButton, progresscolor, loading, ...props }) => {
  const CMButton = getButton(buttonType);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
    }
  };

  return (
    <CMButton {...props} onKeyDown={handleKeyDown}>
      {isProgressButton && loading ?
        <LoadingButtonContainer>
          <CMProgress progresscolor={progresscolor} thickness={5} size={20} value={100} variant='indeterminate' disableShrink sx={{
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }} />
        </LoadingButtonContainer>
        : <>{children}</>
      }
    </CMButton>
  )
}

export default Button;